import { render, staticRenderFns } from "./Egreso.vue?vue&type=template&id=68679acf&scoped=true"
import script from "./Egreso.vue?vue&type=script&lang=js"
export * from "./Egreso.vue?vue&type=script&lang=js"
import style0 from "./Egreso.vue?vue&type=style&index=0&id=68679acf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68679acf",
  null
  
)

export default component.exports